export default class Group {
  constructor(groupsList, name) {
    this.id = "0";
    this.name = name;
    this.poi_img = "0";
    this.schedule = "";
    this.mosaic = false;
    this.image = "";
    if (groupsList != null) {
      let i = 1000;
      let id = i.toString();
      while (groupsList.findIndex((c) => c.id == id) != -1) {
        i++;
        id = i.toString();
      }
      this.id = id;
    }
  }
}
